<template>
  <div>
    <forms-vue
      v-bind:title="title"
      v-bind:form="form"
      v-bind:submit_url="submit_url"
      v-bind:redirect_submit_url="redirect_submit_url"
      v-bind:edit_get_url="edit_get_url"
      v-bind:watch="watch"
      v-bind:submit_in_url="submit_in_url"
    ></forms-vue>
  </div>
</template>
<script type="text/javascript">
export default {
  data() {
    return {
      title: "Alta de Registro",
      submit_url: this.$root.UrlBase("registro/nuevo"),
      redirect_submit_url: "Alta de Tipos",
      edit_get_url: "",
      submit_in_url: true,
      watch: [],
      form: [
        [
          {
            col: "12",
            title: "Datos",
            footer: {},
            attrs: [
              [
                {
                  pretty_name: "Descripción",
                  name: "descripcion",
                  desc: "text",
                  type: "text",
                  value: "",
                  cols: "6",
                },
                {
                  pretty_name: "Numeración",
                  name: "nodo_numer",
                  desc: "nodo_numer",
                  type: "select",
                  value: "",
                  options: [],
                  cols: "6",
                },
              ],
              [
                {
                  pretty_name: "Usa Cliente/Proveed./Personal:	",
                  name: "marca_clien_prove",
                  desc: "marca_clien_prove",
                  type: "select",
                  value: "",
                  options: [
                    // { label: "Ninguno", code: null },
                    { label: "Cliente", code: "C" },
                    { label: "Proveedor", code: "P" },
                    { label: "Personal", code: "E" },
                  ],
                  cols: "12",
                },
              ],
              [
                {
                  pretty_name: "Utiliza Area de Proceso:",
                  name: "marca_usa_proceso",
                  desc: "marca_usa_proceso",
                  type: "select",
                  value: "S",
                  options: [
                    { label: "Si", code: "S" },
                    { label: "No", code: "N" },
                  ],
                  cols: "6",
                },
                {
                  pretty_name: "Descrip. Proceso:",
                  name: "descrip_proceso",
                  desc: "descrip_proceso",
                  type: "text",
                  value: "Area de Proceso",
                  cols: "6",
                },
              ],
              [
                {
                  pretty_name: "Utiliza Clasificación:",
                  name: "marca_usa_clasifica",
                  desc: "marca_usa_clasifica",
                  type: "select",
                  value: "S",
                  options: [
                    { label: "Si", code: "S" },
                    { label: "No", code: "N" },
                  ],
                  cols: "6",
                },
                {
                  pretty_name: "Descrip. Clasificación:",
                  name: "descrip_clasifica",
                  desc: "text",
                  type: "text",
                  value: "Clasificación",
                  cols: "6",
                },
              ],
              [
                {
                  pretty_name: "Utiliza botones Aprobar/Rechazar:",
                  name: "marca_usa_aprobar_rechazar",
                  desc: "marca_usa_aprobar_rechazar",
                  type: "select",
                  value: "N",
                  options: [
                    { label: "Si", code: "S" },
                    { label: "No", code: "N" },
                  ],
                  cols: "4",
                },
                {
                  pretty_name: "El Rechazo retorna a la Etapa Inicial:",
                  name: "marca_regresa_etapa_inicial",
                  desc: "marca_regresa_etapa_inicial",
                  type: "select",
                  value: "N",
                  options: [
                    { label: "Si", code: "S" },
                    { label: "No", code: "N" },
                  ],
                  cols: "4",
                },
                {
                  pretty_name: "Nivel de Importancia en subida Archivos:",
                  name: "marca_usa_nivel_archivo",
                  desc: "marca_usa_nivel_archivo",
                  type: "select",
                  value: "N",
                  options: [
                    { label: "Si", code: "S" },
                    { label: "No", code: "N" },
                  ],
                  cols: "4",
                },
              ],
              [
                {
                  pretty_name: "Título del Formulario:	",
                  name: "titulo_formulario",
                  desc: "titulo_formulario",
                  type: "text",
                  value: "",
                  cols: "8",
                },
                {
                  pretty_name: "Estado:",
                  name: "estado",
                  desc: "estado",
                  type: "select",
                  value: "A",
                  options: [
                    { label: "Activo", code: "A" },
                    { label: "Deshabilitado", code: "B" },
                  ],
                  cols: "4",
                },
              ],
            ],
            footer: {
              buttons: [
                {
                  type: "button",
                  text: "Cancelar",
                  class: "btn btn-danger pull-left",
                  route: "HomeSections",
                },
              ],
            },
          },
        ],
      ],
    };
  },
  created() {
    const data = {
      selects: {
        // User: {},
        Numeracion: {  },
      },
    };
    this.$root
      .Consulta(
        this.$root.UrlBase("selects/init"),
        data,
        "post",
        false,
        false,
        false,
        "",
        false
      )
      .then((response) => {
        // this.form[0][0].attrs[0][1].options = response.User;
        // this.form[0][1].attrs[0][2].options = response.User;
        this.form[0][0].attrs[0][1].options = response.Numeracion;
      });
  },
  watch: {},
};
</script>
